module.exports = __webpack_public_path__ + "img/wondern64_ua.d17fd133.webp";